import React, { ReactNode } from 'react';
import classNames from 'classnames';
import { notNil } from '../../../../core/helpers/is-nil';
import { Icon } from '../../../icon/icon';
import { IconVariant } from '../../../icon/icon-data';
import { Link } from '../../../link/link';
import styles from './table-cell-icon-label.module.scss';

type Props = {
  variant: IconVariant;
  iconColor?: 'red' | 'black';
  iconPosition?: 'left' | 'right';
  children?: ReactNode;
  link?: {
    ariaLabel: string;
    to: string;
  };
};

export const TableCellIconLabel: React.FC<Props> = ({
  variant,
  iconColor = 'black',
  iconPosition = 'left',
  children,
  link,
}) => {
  const hasLink = notNil(link);
  const isRed = iconColor === 'red';
  const isBlack = !isRed;

  const icon = (
    <Icon
      size="24"
      variant={variant}
      className={classNames(styles.icon, {
        [styles.iconRed]: isRed,
        [styles.iconBlack]: isBlack,
      })}
    />
  );

  return (
    <div className={styles.root}>
      {hasLink ? (
        <Link aria-label={link.ariaLabel} icon={variant} to={link.to} />
      ) : (
        <>
          {iconPosition === 'left' && icon}
          {children}
          {iconPosition === 'right' && icon}
        </>
      )}
    </div>
  );
};
